import axios from 'axios';

import { TOKEN_EXPIRED, TIMEOUT, INTERNAL_ERROR } from "../hooks/useAPIHelper";

const GET_ASSETS_URL = '/.netlify/functions/xServiceGetServiceContractUnits';

const GetAssetsListFunction = async (filter: string, token:string ,selectedContract:string) => {

  const fetchData = async (): Promise<any> => {
      try {
        const assetDataRes = await axios({
          method: 'POST',
          url: GET_ASSETS_URL,
          headers: {
            'Content-Type': 'application/json',
            'X-Pronto-Token': token,
          },
          data: `${filter}`,
        });

        if (assetDataRes.status === 200) {
          if (assetDataRes.data.ServiceGetServiceContractUnitsResponse.ServiceContractUnits) {
            return assetDataRes.data.ServiceGetServiceContractUnitsResponse.ServiceContractUnits.ServiceContractUnit;
          } else {
            return [];
          }
        }
      } catch (err) {
        if(err.response.status == 504) {
          throw(TIMEOUT);
        } else if(err.response.status == 401) {
            if(err.response.data == 'TokenExpired') {
              throw(TOKEN_EXPIRED);
            }
        }
      }
    };

    return fetchData();
};

export default GetAssetsListFunction;
